// extracted by mini-css-extract-plugin
module.exports = {"title-row":"styles_title-row__1g76R","title":"styles_title__1iXf3","countdown-timer":"styles_countdown-timer__1ceSK","button-row":"styles_button-row__3iZI0"};